import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { getVaspWalletList } from '../vaspWalletEndpoints'
import type { GetVaspWalletListParams } from '../../types/cryptoWalletTypes'

export function useVaspWalletListQuery(
  filters: MaybeRefOrGetter<Partial<GetVaspWalletListParams>>,
) {
  return useQuery({
    queryKey: () => cryptoWalletsKeys.vaspWalletList(toValue(filters)),
    queryFn: () =>
      getVaspWalletList({
        page: 1,
        limit: 10,
        ...toValue(filters),
      }),
    // Keeps the previous page rendered while the next one loads, so paging and
    // card-switching don't blank the table under the operator's cursor.
    placeholderData: keepPreviousData,
  })
}
